import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
// import Route from 'route-parser';
// import Axios from 'axios';
// import {
//   editToolingManagementRoute,
//   // accountAdminRoute,
// } from '../../../config/navigation/routes';
import { toolingById } from '../../../graphql/item';
import { editTool, getToolAccessLevels, getToolCategories } from '../../../graphql/tooling';
// import { forwardTo } from '../../../utils/browserHistoryUtils';

export default function EditToolingManagementHOC(EditToolingManagementPage) {
  class WrappedComponent extends Component {
    static propTypes = {
      auth: PropTypes.shape({
        id: PropTypes.string,
        role: PropTypes.string,
        expiration: PropTypes.number,
        organizationId: PropTypes.string,
        email: PropTypes.string,
      }).isRequired,
      selectedItemId: PropTypes.string.isRequired,
      showEditModal: PropTypes.bool.isRequired,
      closeEditModal: PropTypes.func.isRequired,
      reloadItems: PropTypes.func.isRequired,
    };

    static initialState = {
      formValues: {
        accessLevel: {
          selectValueA: '',
          selectValueACopy: '',
          displayValues: [],
        },
        category: {
          selectValueC: '',
          selectValueCCopy: '',
          displayValues: [],
        },
      },
      isLoading: true,
      errors: [],
      message: '',
      type: '',
    };

    state = WrappedComponent.initialState;

    async componentDidMount() {

      const {
        toolingById: { item },
      } = await toolingById(this.props.selectedItemId);

      const accessLevelOptions = this._createOptions(
        await this._optionsAccessLevelData(),
      );
      const defValueA = Object.keys(JSON.parse(item.accessLevel))[0];
      const categoryOptions = this._createOptions(
        await this._optionsCategoryData(),
      );
      const defValueC = Object.keys(JSON.parse(item.category))[0];

      this.setState({
        formValues: {
          accessLevel: {
            selectValueA: defValueA,
            selectValueACopy: defValueA,
            displayValues: accessLevelOptions,
          },
          category: {
            selectValueC: defValueC,
            selectValueCCopy: defValueC,
            displayValues: categoryOptions,
          },

          cage: item.cage,
          comments: item.comments,
          description: item.description,
          designAlloy: item.designAlloy,
          id: item.id,
          niin: item.niin,
          ownerCage: item.ownerCage.trim(),
          partNum: item.partNum,
          toolingRef: item.toolingRef,
        },
        isLoading: false,
      });

      const formValues = { ...this.state.formValues };
      this.setState({ formValues });
    }

    _createOptions = obj => {
      const keys = Object.keys(obj);
      const options = keys.map(key => ({ text: obj[key], value: key }));
      return options;
    };

    _optionsAccessLevelData = async () => {
      let res = '';
      res = await getToolAccessLevels();
      return res;
    };

    _optionsCategoryData = async () => {
      let res = '';
      res = await getToolCategories();
      return res;
    };

    _onSubmit = async event => {
      const { organizationId, email } = this.props.auth;
      const { selectedItemId } = this.props;

      const obj = {
        ...event,
      };
      obj.accessLevel = obj.accessLevel.selectValueA;
      obj.category = obj.category.selectValueC;
      obj.modifiedBy = email;

      try {
        const { updateTool } = await editTool({
          id: selectedItemId,
          ...obj,
          organizationId,
        });

        if (updateTool.status === 'success') {
          this.setState({
            message: 'Tooling Management Updated!',
            type: 'success',
          });
          // NFFS-442
          setTimeout(() => { this.props.closeEditModal(); this.props.reloadItems() }, 1000);
        } else {
          this.setState({
            message: 'Unable to update tooling. Please try again in a few minutes',
            type: 'warning',
          });
        }
      } catch (error) {
        this.setState({
          message: 'Unable to update tooling.',
          type: 'warning',
        });
      }

    };

    _handleInitalValueReset = () => {
      // CATHARINA TODO use old state
      const formValues = { ...this.state.formValues };
      formValues.accessLevel.selectValueA = this.state.formValues.accessLevel.selectValueACopy;
      formValues.category.selectValueC = this.state.formValues.category.selectValueCCopy;
      this.setState({ formValues });
    };

    render() {
      const { formValues, isLoading, errors, message, type } = this.state;
      const { showEditModal, closeEditModal } = this.props;

      // Configure Page
      const pageProps = {
        formValues,
        isLoading,
        onSubmit: this._onSubmit,
        handleInitalValueReset: this._handleInitalValueReset,
        createOptions: this._createOptions,
        optionsAccessLevelData: this._optionsAccessLevelData,
        optionsCategoryData: this._optionsCategoryData,
        errors,
        message,
        type,
        showEditModal,
        closeEditModal,
      };

      return <EditToolingManagementPage {...pageProps} />;
    }
  }

  return withRouter(WrappedComponent);
}



// WEBPACK FOOTER //
// ./src/components/Modals/EditToolingManagement/EditToolingManagementHOC.jsx